import { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import * as D from "assets/iconsSVG/deleteIconModal";
import * as MaterialUI from "@material-ui/core";
import { useTransferirLead } from "services/api/AppWeb_Oportunidade/put-transferir-lead";
import InputComponent from "components/InputG";
import { useDeleteCampanha } from "services/api/Common_Campanhas/delete-campanha";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  campanhasRefetch: () => void;
  idCampanha: string;
}

export const ModalDeletarCampanha = (data: Data) => {
  const { mutate: mutateDeleteCampanha, isLoading: isLoadingDeleteCampanha } =
    useDeleteCampanha();

  const handleSubmit = () => {
    mutateDeleteCampanha(
      {
        idCampanha: data.idCampanha,
      },
      {
        onSuccess: () => {
          data.campanhasRefetch();
          data.onClose();
        },
        onError: (error: any) => {
          const notifications = error?.response?.data?.notifications;
          const errorMessages = Array.isArray(notifications)
            ? notifications.map((item: any) => `\n${item?.message}\n`).join("")
            : "Erro ao deletar campanha. Tente novamente.";
          toast.error(errorMessages, { autoClose: 10000 });
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <D.DeleteIconModal />
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
        <S.SpaceY space={16} />
        <S.TextTitle>Deletar Campanha</S.TextTitle>
      </S.Header>
      <S.SpaceY space={16} />
      <S.Body>
        <S.Row style={{ gap: 16 }}>
          <S.TextDescription>
            Tem certeza que deseja deletar a campanha?
          </S.TextDescription>
        </S.Row>
        <S.SpaceY space={32} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={() => {
              data.onClose();
            }}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingDeleteCampanha}
            color="#F43636"
          >
            {isLoadingDeleteCampanha ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Deletar</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};
